"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveEmail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var certification_1 = require("../../model/certification");
var service_1 = require("../../../library/base/service");
var SaveEmail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SaveEmail, _super);
    function SaveEmail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '保存邮箱';
        _this.code = '101169';
        _this.desc = '保存邮箱';
        _this.requestParams = new certification_1.SaveEmailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SaveEmail;
}(service_1.BaseService));
exports.SaveEmail = SaveEmail;
//# sourceMappingURL=saveEmail.js.map